import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { searchApi, categoryApi, gmtsApi } from '@services'

const initialState = {
  searchStores: [] as any,
  foodCategoryGroups: [] as any,
  priceRanges: [] as any,
  isLoading: false
}

export const fetchDataSearch = createAsyncThunk(
  'store/fetchDataSearch',
  async (params: any = {}) => {
    const response = await searchApi.fetchDataSearch(params)
    return response.data
  }
)

export const getFoodCategoryGroup = createAsyncThunk(
  'store/getFoodCategoryGroup',
  async () => {
    const response = await categoryApi.getFoodCategoryGroup()
    return response.data
  }
)

export const getPriceRange = createAsyncThunk(
  'store/PriceRange',
  async () => {
    const response = await gmtsApi.getPriceRange()
    return response.data
  }
)

const searchStoreSlice = createSlice({
  name: 'searchStore',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchDataSearch.fulfilled, (state, action) => {
      state.searchStores = action.payload
    })
    builder.addCase(getFoodCategoryGroup.fulfilled, (state, action) => {
      state.foodCategoryGroups = action.payload
    })
    builder.addCase(getPriceRange.fulfilled, (state, action) => {
      state.priceRanges = action.payload
    })
  }
})

export const {
  setLoading
} = searchStoreSlice.actions

export default searchStoreSlice.reducer
